module.exports = __webpack_public_path__ + "static/media/us.038c3e12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/us.jpg
// module id = 132
// module chunks = 0